import actionTypes from '../../common/actionTypes';

interface State {
	types: Array<PickListType>;
	items: Array<PickListItem>;
	type: PickListType;
	item: PickListItem;
}
const initialState = {
	types: [],
	items: [],
	type: {},
	item: {}
};
export default function pickListReducer(state: State = initialState, action: any) {
	switch (action.type) {
		case actionTypes.SET_PICKLIST_TYPE_SUCCESS:
			return { ...state, type: action.pickListType };
		case actionTypes.SET_PICKLIST_ITEM_SUCCESS:
			return { ...state, item: action.pickListItem };
		case actionTypes.GET_PICKLIST_TYPE_SUCCESS:
			return { ...state, type: action.pickListType };
		case actionTypes.GET_PICKLIST_TYPES_SUCCESS:
			return { ...state, types: action.pickListTypes };
		case actionTypes.GET_PICKLIST_ITEM_SUCCESS:
			return { ...state, item: action.pickListItem };
		case actionTypes.GET_PICKLIST_ITEMS_SUCCESS:
			return { ...state, items: action.pickListItems };
		case actionTypes.SAVE_PICKLIST_TYPE_SUCCESS:
			let filteredTypes = state.types.filter(type => type.id !== action.pickListType.id);
			return {
				...state,
				types: [...filteredTypes, action.pickListType],
				type: action.pickListType
			};
		case actionTypes.SAVE_PICKLIST_ITEM_SUCCESS:
			let filteredItems = state.items.filter(item => item.id !== action.pickListItem.id);
			return {
				...state,
				items: [...filteredItems, action.pickListItem],
				item: action.pickListItem
			};
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/PickList/pickListReducer.ts